import * as Yup from 'yup';

export const levelRewardSchema = Yup.object({
  title: Yup.string().required('El título es obligatorio'),
  level: Yup.number().min(1, 'El nivel debe ser al menos 1').required('El nivel es obligatorio'),
  rewardType: Yup.string().oneOf(
    ['xp_bonus', 'blockchain_token', 'treasure_opportunity', 'claw_coin', 'store_discount', 'custom_reward'],
    'Tipo de premio inválido'
  ).required('El tipo de premio es obligatorio'),
  rewardConfig: Yup.object().when('rewardType', ([rewardType], schema) => {
    switch (rewardType) {
      case 'xp_bonus':
        return Yup.object({
          amount: Yup.number().min(1, 'La cantidad de XP debe ser al menos 1').required('La cantidad de XP es obligatoria'),
        });
      case 'blockchain_token':
        return Yup.object({
          networkId: Yup.number().required('El ID de la red es obligatorio'),
          tokenId: Yup.number().required('El ID del token es obligatorio'),
          quantity: Yup.string().matches(/^\d+([.,]\d+)?$/, 'La cantidad debe ser un número válido (puede incluir decimales con coma o punto)').required('La cantidad es obligatoria'),
        });
      case 'treasure_opportunity':
        return Yup.object({
          amount: Yup.number().min(1, 'La cantidad de oportunidades debe ser al menos 1').required('La cantidad de oportunidades es obligatoria'),
        });
      case 'claw_coin':
        return Yup.object({
          amount: Yup.number().min(1, 'La cantidad de monedas debe ser al menos 1').required('La cantidad de monedas es obligatoria'),
          expirationDays: Yup.number().min(1, 'Los días de expiración deben ser al menos 1').nullable().transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          }).optional(),
        });
      case 'store_discount':
        return Yup.object({
          discountPercentage: Yup.number().min(1, 'El porcentaje de descuento debe ser al menos 1').max(100, 'El porcentaje de descuento no puede exceder 100').required('El porcentaje de descuento es obligatorio'),
          discountLimit: Yup.number().min(1, 'El límite de uso debe ser al menos 1').required('El límite de descuento es obligatorio'),
          discountExpirationDays: Yup.number().min(1, 'Los días de expiración deben ser al menos 1').required('Los días de expiración son obligatorios'),
        });
      case 'custom_reward':
        return Yup.object({
          icon: Yup.string().required('El ícono del premio personalizado es obligatorio'),
          link: Yup.string().optional(),
        });
      default:
        return schema;
    }
  }),
  active: Yup.boolean().required('El estado activo es obligatorio'),
  priority: Yup.number().min(0, 'La prioridad debe ser al menos 0').required('La prioridad es obligatoria'),
  extraData: Yup.object({
    en: Yup.object({
      title: Yup.string().optional(),
      icon: Yup.string().optional(),
    }).optional(),
    pt: Yup.object({
      title: Yup.string().optional(),
      icon: Yup.string().optional(),
    }).optional(),
  }).optional(),
})

export type LevelRewardFormData = {
  title: string;
  level: number;
  rewardType: 'xp_bonus' | 'blockchain_token' | 'treasure_opportunity' | 'claw_coin' | 'store_discount' | 'custom_reward';
  rewardConfig: any;
  active: boolean;
  priority: number;
  extraData?: {
    en?: {
      title?: string;
      icon?: string;
    };
    pt?: {
      title?: string;
      icon?: string;
    };
  };
}